import { string } from 'yup';

const obj = {
  field: [
    {
      title: "Email composer",
      attr: "content",
      value: "",
      id: "content",
      placeholder: "When doing an your taxes, it's important to...",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Email composer is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  example: [
    {
      title: "Email Composer",
      attr: "content",
      value: "Content",
      id: "content",
      placeholder: "When doing an your taxes, it's important to...",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Email Composer is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  editor: {
    output: `I hope you are having a good day. I am writing to request leave for the day due to health issues. I would like to be able to take the day off on Friday, September 8th. Thank you for your time and consideration.\nSincerely,\n[Your Name] `, 
          },
};

export default obj;
